import React, { useEffect, useState } from 'react'
import ProfileImg from '../assets/profile.png';
import '../css/Admin/ViewParty.css';
import 'animate.css'
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';
import PdfImg from '../assets/pdf-img.webp';
import { Link } from 'react-router-dom';

const ViewParty = ({ userData }) => {
  const [party, setParty] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [response, setResponse] = useState();
  const [selectedParty, setSelectedParty] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedImg, setSelectedImg] = useState();
  const [fullImg, setFullImg] = useState(false);
  const [orders, setOrders] = useState([]);
  const [payData, setPayData] = useState([]);
  const [showDiscount, setShowDiscount] = useState(false);
  const [formData, setFormData] = useState({
    allot_discount: '',
  })


  useEffect(() => {
    const fetchParty = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcmstore.in/dist/get-party');
        setLoading(false);

        if (response.ok) {
          const data = await response.json();
          const filteredParty = data.filter(user => user.id !== userData.id);
          setParty(filteredParty);
        } else {
          setLoading(false);
          console.error('Failed to fetch users');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching users:', error);
      }
    };

    const fetchOrders = async () => {
      setLoading(true);

      try {
        const response = await fetch(`https://api.kcmstore.in/dist/get-orders`);
        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setOrders(sortedProducts);
        } else {
          setLoading(false);
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };

    const fetchPayments = async () => {
      setLoading(true);
      try {
          const response = await fetch(`https://api.kcmstore.in/dist/get-payment-history`);
          setLoading(false);

          if (response.ok) {
              const data = await response.json();
              const sortedProducts = data.sort((a, b) => b.id - a.id);
              setPayData(sortedProducts);
          } else {
              setLoading(false);
              console.error('Failed to fetch products');
          }
      } catch (error) {
          setLoading(false);
          console.error('Error fetching products:', error);
      }
  };

    fetchParty();
    fetchOrders();
    fetchPayments();
  }, []);

  


  const handleShowDetail = (partyData) => {
    setSelectedParty(partyData);
    setShowDetail(true);
  }

  const handleShowDiscount = (partyData) => {
    setSelectedParty(partyData);
    setFormData({
      allot_discount: partyData.discount_allot
    })
    setShowDiscount(true);
  }


  const handleChange = (e) => {
    const { id, value} = e.target;
        setFormData({
            ...formData,
            [id]: value,
        });
};

const updateDiscount = async (e) => {
  e.preventDefault();
  setLoading(true);

  console.log(formData);
  try {
    // Send data to backend
    const response = await fetch(`https://api.kcmstore.in/dist/update-alloted-discount/${selectedParty.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    
    const result = await response.json();
    setLoading(false);

    if (response.ok) {
        setResponse('Alloted Discount Updated!');
        setShowDiscount(false);
        setTimeout(() => {
            setResponse('');
            window.location.reload();
        }, 1500);
    } else {
        setLoading(false);
        setResponse('Failed to update discount.');
        setTimeout(() => {
            setResponse('');
        }, 2000);
    }
} catch (error) {
    setLoading(false);
    console.error('Error updating discount:', error);
}

}

  const deleteParty = async () => {
    if (selectedParty) {
      setLoading(true);

      try {
        const response = await fetch(`https://api.kcmstore.in/dist/delete-party/${selectedParty.id}`, {
          method: 'DELETE',
        });
        setLoading(false);

        if (response.ok) {
          setParty((prevParties) => prevParties.filter(party => party.id !== selectedParty.id));
          setResponse("Party removed successfully!");
            setShowDelete(false);
            setShowDetail(false);
          setTimeout(() => {
            setResponse('');
          }, 2000);
        } else {
          setLoading(false);
          setResponse("Unable to remove party.");
          setTimeout(() => {
            setResponse('');
          }, 2000);
        }
      } catch (error) {
        setLoading(false);
        console.error('Error deleting party:', error);
      }
    }
  }


  const renderImageOrIcon = (fileName) => {
    const fileExtension = fileName ? fileName.split('.').pop().toLowerCase() : '';

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff'].includes(fileExtension)) {
      // If file is an image, render the image
      return (
        <img
          src={`https://api.kcmstore.in/uploads/${fileName}`}
          className="doc-img w-auto my-2"
          alt="Drug License"
          onClick={() => handleSetFullImg(fileName)}
        />
      );
    } else if (fileExtension === 'pdf') {
      // If file is a PDF, render a PDF icon
      return (
        <Link to={`https://api.kcmstore.in/uploads/${fileName}`} className='bg-white mb-3 rounded-3' target='_blank'>
          <img
            src={PdfImg}
            className="doc-img w-auto py-2"
            alt="Drug License" />
        </Link>
      );
    }
    // If the file is neither image nor PDF, render nothing
    return <p className='my-0 para-text fst-italic text-muted'>Document not Available</p>;
  };

  const handleSetFullImg = (filename) => {
    setSelectedImg(filename);
    setFullImg(true);
  }

  const filteredParty = party.filter(myParty =>
    (myParty.name?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myParty.mobile?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
    // (myParty.address?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    // (myParty.city?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    // (myParty.state?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    // (myParty.pincode?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
  );


  const getTotalSales = (partyId) => {
    const partyOrders = orders.filter(order => order.user_id === partyId);
    const total = partyOrders.reduce((sum, order) => sum + Number(order.total_amount || 0), 0);
    return total.toFixed(2);
  };
  

  const getTotalPaid = (partyId) => {
    const partyOrders = orders.filter(order => order.user_id === partyId);
      const partyOrderIds = partyOrders.map(order => order.id);
  
    // Filter payment data where order_id matches one of party's orders
    const partyPayments = payData.filter(payment => partyOrderIds.includes(payment.order_id));
  
    const totalPaid = partyPayments.reduce((sum, payment) => sum + Number(payment.amount_received || 0), 0);
  
    return totalPaid.toFixed(2);
  };
  

  return (
    <>
      <section className='px-md-3 px-sm-3 py-3'>
        <div className='profile-area-inner px-lg-4 py-lg-4 px-3 py-3'>
          <p className='profile-heading'>View Party</p>
          {/* <hr className='profile-hr' /> */}

          <div className='d-flex bg-light rounded-4 py-2'>
            <i class="fa-solid fa-magnifying-glass text-darkblue py-2 px-3"></i>
            <input
              type="text"
              className="form-input rounded-4 border-0 bg-light w-100"
              placeholder="Search Party by Name/ Mobile"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className='row mt-4'>

            {filteredParty.length > 0 ? (
              filteredParty.map((partyData) => (
                <div className='col-lg-4 col-md-6 col-12 my-2'>
                  <div className='profile-card'>
                    <div className='profile-img-area'>
                      <img src={ProfileImg} className='profile-img' alt='Profile' />
                      <p className='ms-3 py-2'>{partyData.name || 'NA'}<br />{partyData.city} {partyData.state} {partyData.pincode}</p>

                    </div>
                    <div className='text-start py-2 px-4'>
                      <p className='profile-text para-text my-0'>Mobile: {partyData.mobile || 'NA'}</p>
                      <p className='profile-text para-text fw-semibold my-0 text-primary'>Order Sales: ₹{getTotalSales(partyData.id)}</p>
                      <p className='profile-text para-text fw-semibold my-0 text-success'>Amount Paid: ₹{getTotalPaid(partyData.id)}</p>
                      <p className='profile-text para-text fw-semibold my-0 text-danger'>Alloted Discount: {partyData.discount_allot}%</p>

                      <div className='text-center mt-3'>
                      <button className='login-btn para-text my-2 px-3 py-2' onClick={() => handleShowDiscount(partyData)}>Edit Discount</button>&nbsp;&nbsp;
                      <button className='login-btn para-text my-2 px-3 py-2' onClick={() => handleShowDetail(partyData)}><i class="fa-solid fa-list-ul me-2"></i>Details</button></div>

                    </div>

                  </div>
                </div>
              ))
            ) : (
              <p className='fw-bold'>No Party Added yet.</p>
            )}


          </div>
          {/* row ends */}

        </div>
      </section>


      {showDetail && (
        <>
          <section className='detail-dialog' onClick={() => setShowDetail(false)}>
            <div className='detail-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>

              <p className='profile-subheading'>Party Details</p>
              <div className='row bg-light px-3 py-3'>
                <div className='col-md-6 px-0'><p className='profile-text'>Party Name: {selectedParty.name || 'NA'}</p></div>
                <div className='col-md-6 ps-lg-3 ps-md-3 px-0'><p className='profile-text'>Email: {selectedParty.email || 'NA'}</p></div>

                <div className='col-md-6 px-0'><p className='profile-text'>Mobile: {selectedParty.mobile || 'NA'}</p></div>
                <div className='col-md-6 ps-lg-3 ps-md-3 px-0'><p className='profile-text'>Password: {selectedParty.password || 'NA'}</p></div>

                <div className='col-md-6 px-0'><p className='profile-text'>Address: {selectedParty.address || ''} {selectedParty.city || ''} {selectedParty.state || ''} {selectedParty.pincode || ''}</p></div>
                <div className='col-md-6 ps-lg-3 ps-md-3 px-0'><p className='profile-text'>Alloted Discount: {`${selectedParty.discount_allot == null ? 'NA' : `${selectedParty.discount_allot}%`}`}</p></div>

                {/* <div className='col-md-6 px-0'><p className='profile-text'>GSTIN No: {selectedParty.gst || 'NA'}</p></div>
                <div className='col-md-6 ps-lg-3 ps-md-3 px-0'><p className='profile-text'>GSTIN Type: {selectedParty.gst_type || 'NA'}</p></div> */}

                {/* <div className='col-md-6 px-0'><p className='profile-text'>GSTIN State: {selectedParty.gst_state || 'NA'}</p></div>
                <div className='col-md-6 ps-lg-3 ps-md-3 px-0'><p className='profile-text'>GSTIN Address: {selectedParty.gst_address || 'NA'}</p></div> */}

                <div className='col-12 px-0'><p className='profile-text'>GSTIN No: {selectedParty.gst || 'NA'}<br />{renderImageOrIcon(selectedParty.gst_image)}</p></div>

                <div className='col-12 px-0'><p className='profile-text'>Permanent Account No: {selectedParty.pan || 'NA'}<br />
                  {renderImageOrIcon(selectedParty.pan_image)}</p></div>

                <div className='col-12 px-0'><p className='profile-text'>Drug License Number: {selectedParty.drug_license || 'NA'}<br />
                  {renderImageOrIcon(selectedParty.drug_image)}</p></div>


              </div>
              {/* row ends */}

              <button className='login-btn px-3 py-2 mt-4' onClick={() => setShowDetail(false)}>Close</button>&nbsp;&nbsp;
              <button className='login-btn px-3 py-2 mt-4 bg-danger' onClick={() => setShowDelete(true)}>Remove</button>

            </div>
          </section>
        </>
      )}

      {/* deleteParty() */}
      {showDelete && (
        <section className='detail-dialog animate__animated animate__zoomIn' onClick={() => setShowDelete(false)}>
          <div className='detail-dialog-inner col-lg-5 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

            <p className='profile-subheading'>Want to remove this Party?</p>

            <button className='login-btn px-3 py-1' onClick={() => deleteParty()}>Yes</button>&nbsp;&nbsp;
            <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowDelete(false)}>No</button>

          </div>
        </section>
      )}

      {fullImg && (
        <section className='detail-dialog'>
          <div className='detail-dialog-inner col-lg-6 mx-auto px-lg-4 py-lg-4 px-2 pb-2 text-center'>
            <img
              src={`https://api.kcmstore.in/uploads/${selectedImg}`}
              className="img-fluid my-2"
              alt="Drug License"
              onClick={() => setFullImg(true)}
            /><br />

            <button className='login-btn px-3 py-1 mt-2 bg-danger' onClick={() => setFullImg(false)}>Close</button>


          </div>
        </section>
      )}


{showDiscount && (
        <section className='detail-dialog animate__animated animate__zoomIn' onClick={() => setShowDiscount(false)}>
          <div className='detail-dialog-inner col-lg-5 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

            <p className='profile-subheading'>Update Discount alloted to this Party</p>

            <div className="col-12 my-4 text-start">
                                                <label htmlFor="allot_discount" className="profile-label text-dark">Alloted Discount %</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="allot_discount"
                                                    value={formData.allot_discount}
                                                    onChange={handleChange}
                                                />
                                            </div>

            <button className='login-btn px-3 py-1' onClick={updateDiscount}>Update</button>&nbsp;&nbsp;
            <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowDiscount(false)}>No</button>

          </div>
        </section>
      )}

      {loading && <Loading setLoading={setLoading} />}

      {response && <ResponseMsg message={response} />}

    </>
  )
}

export default ViewParty
